import { createContext, useContext } from "react";
import { TradePlanData } from "./tradePlanData";

interface FormContext extends TradePlanData {
  value?: TradePlanData;
}
interface ProviderProps {
  store: TradePlanData;
  children?: JSX.Element | JSX.Element[];
}
const TradePlanFormContext = createContext<FormContext | null>(null);
export const useTradePlanFormStore = () => useContext(TradePlanFormContext);
export const TradePlanFormProvider: React.FC<ProviderProps> = ({ store, children }) => {
  return (
    <TradePlanFormContext.Provider value={store}>
      {children}
    </TradePlanFormContext.Provider>
  );
};
